module.exports = __webpack_public_path__ + "img/trash_recover.9f3e8170.png";